/* src/app/Presentation/components/disclaimer/disclaimer.component.scss */
/*# sourceMappingURL=disclaimer.component.css.map */
